import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useShopFlag } from "@/hooks/use-flag.ts";
import AllQuickFilter from "./all-quick-filter";
import CarrierErrorQuickFilter from "./carrier-error-quick-filter";
import MarketplaceQuickFilter from "./marketplace-quick-filter.tsx";
import ShippingTooLongQuickFilter from "./shipping-to-long-quick-filter";
import ToBeTreatedQuickFilter from "./to-be-treated-quick-filter";
import ToValidateQuickFilter from "./to-validate-quick-filter";
import TreatedWithoutLogisticianInspectionQuickFilter from "./treated-without-logistician-inspection-quick-filter";

export function QuickFiltersBar() {
  const { data: shop } = useCurrentShopSuspense();
  const isMarketplaceQuickFilterEnabled = useShopFlag(
    "isMarketplaceQuickFilterEnabled",
  );
  const isWorkflowLogisticianActivated = shop.workflowLogistician.activated;

  return (
    <div className="flex gap-4 overflow-auto w-full flex-wrap">
      <AllQuickFilter />
      <ToBeTreatedQuickFilter />
      {isMarketplaceQuickFilterEnabled && <MarketplaceQuickFilter />}
      <ToValidateQuickFilter />
      {isWorkflowLogisticianActivated && (
        <TreatedWithoutLogisticianInspectionQuickFilter />
      )}
      <ShippingTooLongQuickFilter />
      <CarrierErrorQuickFilter />
    </div>
  );
}
